import React, { useEffect } from "react";
import html2pdf from "html2pdf.js";
import "./FlightTicket.css";
import logo from "../../../Images/Jayraj_logo.png";
import { useLocation } from "react-router-dom";
import api from "../../../Api.js";
import { useNavigate } from "react-router-dom";

const FlightTicketDetails = () => {
  const location = useLocation();
  const { flightData } = location.state || {};
  const { FlightDataFromHistoryPage } = location.state || {};
  console.log("Received flight data in FlightTicketDetails:", flightData);
  // const bookingDetails = flightData?.bookingDetails || {};
  const [ticketData, setTicketData] = React.useState(null);
  const navigate = useNavigate();
  useEffect(() => {

    const getTicketData = async () => {
      try {
        // Simulate API call to fetch ticket data  
        const response = await api.post("/flights/booking-details", {
          TraceId: flightData?.data?.responseData?.Response?.TraceId || FlightDataFromHistoryPage?.TraceID,
          BookingId: flightData?.data?.responseData?.Response?.Response?.BookingId.toString() || FlightDataFromHistoryPage?.BookingId.toString(),
          PNR: flightData?.data?.responseData?.Response?.Response?.PNR || FlightDataFromHistoryPage?.PNR

        });
        console.log("Fetched ticket data:", response.data);
        setTicketData(response?.data?.data || null);

      } catch (error) {
        console.error("Error fetching ticket data:", error);
        alert("Failed to load ticket data. Please try again later.");
      }
    };
    if (flightData) {
      getTicketData();
    }

  }, [flightData]);

  console.log("Current ticket data state:", ticketData);
  const handleDownload = () => {
    const ticketElement = document.getElementById("flight-ticket-download-area");

    const options = {
      margin: 10,
      filename: "Flight_E_Ticket.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
    };

    html2pdf().set(options).from(ticketElement).save();
  };

  const handleCancel = () => {
    alert("Ticket cancellation initiated");
  };




  const itinerary = ticketData?.FlightItinerary;
  const segment = itinerary?.Segments?.[0];
  const passenger = itinerary?.Passenger?.[0];
  const fare = itinerary?.Fare;

  const seat = passenger?.SeatDynamic?.[0];
  const meal = passenger?.MealDynamic?.[0];
  const baggage = passenger?.Baggage?.[0];
  const additionalInfo = passenger?.SegmentAdditionalInfo?.[0];

  const formatDateTime = (date) =>
    date
      ? new Date(date).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
      : "—";



  return (
    <>

      <div className="flight-ticket-page">

        <div className="flight-ticket-card">

          {/* 👇 ONLY THIS AREA WILL BE DOWNLOADED */}
          <div id="flight-ticket-download-area">

            <div className="flight-ticket-header">
              <img src={logo} alt="Jayraj Group Logo" className="flight-ticket-logo" width="100" height="50" />
              <h2 className="flight-ticket-title">E-Ticket / Flight Confirmation</h2>
              <div className="flight-ticket-pnr">
                PNR: {itinerary?.PNR}
              </div>

            </div>

            {/* Journey Details */}
            <table className="flight-ticket-table">
              <thead>
                <tr>
                  <th colSpan="4">Journey Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>From</strong></td>
                  <td>
                    {segment?.Origin?.Airport?.CityName} ({segment?.Origin?.Airport?.AirportCode})
                  </td>
                  <td><strong>To</strong></td>
                  <td>
                    {segment?.Destination?.Airport?.CityName} ({segment?.Destination?.Airport?.AirportCode})
                  </td>
                </tr>

                <tr>
                  <td><strong>Airline</strong></td>
                  <td>{segment?.Airline?.AirlineName}</td>
                  <td><strong>Flight No</strong></td>
                  <td>
                    {segment?.Airline?.AirlineCode}-{segment?.Airline?.FlightNumber}
                  </td>
                </tr>

                <tr>
                  <td><strong>Departure</strong></td>
                  <td>{formatDateTime(segment?.Origin?.DepTime)}</td>
                  <td><strong>Arrival</strong></td>
                  <td>{formatDateTime(segment?.Destination?.ArrTime)}</td>
                </tr>
              </tbody>
            </table>
            {/*  ticket dinformation */}
            <table className="flight-ticket-table">
              <thead>
                <tr>
                  <th colSpan="4">Ticket Information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Ticket No</strong></td>
                  <td>{passenger?.Ticket?.TicketNumber}</td>
                  <td><strong>Issue Date</strong></td>
                  <td>{formatDateTime(passenger?.Ticket?.IssueDate)}</td>
                </tr>

                <tr>
                  <td><strong>Invoice No</strong></td>
                  <td>{itinerary?.InvoiceNo}</td>
                  <td><strong>Invoice Amount</strong></td>
                  <td>₹{itinerary?.InvoiceAmount}</td>
                </tr>
              </tbody>
            </table>


            {/* Passenger Details */}
            <table className="flight-ticket-table">
              <thead>
                <tr>
                  <th colSpan="4">Passenger & Services Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Name</strong></td>
                  <td>
                    {passenger?.Title} {passenger?.FirstName} {passenger?.LastName}
                  </td>
                  <td><strong>Status</strong></td>
                  <td>{segment?.FlightStatus}</td>
                </tr>

                <tr>
                  <td><strong>Email</strong></td>
                  <td>{passenger?.Email}</td>
                  <td><strong>Mobile</strong></td>
                  <td>{passenger?.ContactNo}</td>
                </tr>

                <tr>
                  <td><strong>Seat</strong></td>
                  <td>
                    {seat ? `${seat.RowNo}${seat.SeatNo}` : "Not Selected"}
                  </td>
                  <td><strong>Seat Price</strong></td>
                  <td>₹{seat?.Price || 0}</td>
                </tr>

                <tr>
                  <td><strong>Meal</strong></td>
                  <td>
                    {meal?.AirlineDescription || "No Meal"}
                  </td>
                  <td><strong>Meal Price</strong></td>
                  <td>₹{meal?.Price || 0}</td>
                </tr>

                <tr>
                  <td><strong>Extra Baggage</strong></td>
                  <td>
                    {baggage ? `${baggage.Weight} KG` : "Not Added"}
                  </td>
                  <td><strong>Baggage Price</strong></td>
                  <td>₹{baggage?.Price || 0}</td>
                </tr>

                <tr>
                  <td><strong>Cabin Baggage</strong></td>
                  <td colSpan="3">
                    {additionalInfo?.CabinBaggage || "As per airline policy"}
                  </td>
                </tr>
              </tbody>
            </table>



            {/* Fare Summary */}
            <table className="flight-ticket-table">
              <thead>
                <tr>
                  <th colSpan="3">Fare Summary</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Base Fare</td>
                  <td></td>
                  <td className="amount">₹{fare?.BaseFare}</td>
                </tr>

                <tr>
                  <td>Taxes</td>
                  <td></td>
                  <td className="amount">₹{fare?.Tax}</td>
                </tr>

                <tr>
                  <td>Seat Charges</td>
                  <td></td>
                  <td className="amount">₹{fare?.TotalSeatCharges}</td>
                </tr>

                <tr>
                  <td>Meal Charges</td>
                  <td></td>
                  <td className="amount">₹{fare?.TotalMealCharges}</td>
                </tr>

                <tr>
                  <td>Baggage Charges</td>
                  <td></td>
                  <td className="amount">₹{fare?.TotalBaggageCharges}</td>
                </tr>

                <tr className="total-row">
                  <td><strong>Total Paid</strong></td>
                  <td></td>
                  <td className="amount">
                    ₹{fare?.PublishedFare}
                  </td>
                </tr>
              </tbody>
            </table>



          </div>

          {/* Buttons */}
          <div className="flight-ticket-actions">
            <button
              className="flight-ticket-download-btn"
              onClick={handleDownload}
            >
              Download E-Ticket
            </button>

            <button
              className="flight-ticket-cancel-btn"
              onClick={handleCancel}
            >
              Cancel Booking
            </button>
          </div>

        </div>
      </div>
<div class="ticket-btn-row">
  <button class="back-btn left-btn" onClick={()=>navigate("/flight-search-result")}>
    ← Go to Search Page
  </button>

  <button class="back-btn right-btn" onClick={()=>navigate("/profile/flight-info")}>
    Go to Profile Booking History →
  </button>
</div>



    </>

  );
};

export default FlightTicketDetails;
